import classNames from 'classnames/bind';
import React from 'react';

import { withFormsy } from 'formsy-react';
import { i18n } from 'common';

class _AdminTimeInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value||0,
      unit: 'seconds'
    };
  }

  componentWillReceiveProps(props) {
    if (this.props.isPristine()) {
      this.setState({value: props.value||0});
    }
  }

  getUnitScale = () => {
    switch (this.state.unit) {
      case 'minutes': return 60;
      case 'hours': return 60 * 60;
      default: return 1;
    }
  }


  onUnitChange = (ev) =>
    this.setState({
      unit: ev.target.value
    }, this.onBlur);

  onChange = ({target}) =>
    this.setState({
      value: target.value
    });


  onBlur = () => {
    const { value } = this.state;

    let num = new Number(value);
    num *= this.getUnitScale();

    this.props.setValue(num);
  }


  render() {
    const { className } = this.props;
    const isPristine = this.props.isPristine();
    const errorMessage = this.props.getErrorMessage();
    const hasError = !isPristine && errorMessage != null;

    return (
      <div className={classNames("", {'f-error': hasError}, className)}>
        <div className="row">
          <div className="control-label col-sm-3">
            <strong>{this.props.title}</strong>
          </div>

          <div className="col-sm-9">
            <input type="text" value={this.state.value}
                   placeholder={i18n('hint.time')}
                   className="w20" disabled={this.props.disabled}
                   onChange={this.onChange} onBlur={this.onBlur}/>

            <select className="ml1" onChange={this.onUnitChange} disabled={this.props.disabled}>
              <option value='seconds'>{i18n('input.seconds')}</option>
              <option value='minutes'>{i18n('input.minutes')}</option>
              <option value='hours'>{i18n('input.hours')}</option>
            </select>
          </div>
        </div>

        {hasError &&
          <ul className="f-error-message">
            <li>{errorMessage}</li>
          </ul>
        }
      </div>
    );
  }
};

export const AdminTimeInput = withFormsy(_AdminTimeInput);
